export default __webpack_public_path__ + "static/media/fireplace.74de351f.svg";